import { gql } from "@apollo/client";

export const GET_ALL_RESULTADO_PRESUPUESTO = gql`
query GetAllResultadoPresupuesto {
    allResultadoPresupuesto {
        idResultadoPresupuesto
        descripcion
    }
}
`;

export const adaptResultadoPresupuesto = (resultadoPresupuesto) => {
  return {
    id: resultadoPresupuesto?.idResultadoPresupuesto,
    displayName: resultadoPresupuesto?.descripcion
  };
};

export const adaptResultadoPresupuestoArray = (
allResultadoPresupuesto) =>
{
  return structuredClone(allResultadoPresupuesto)?.
  map((resultadoPresupuesto) => adaptResultadoPresupuesto(resultadoPresupuesto));
};